// ===========================================
// Registration fee credit: settings + the Held children of a family (#374 Phase 3)
// ===========================================
// Mirrors services/registrationPayment/{settings,credit}.ts and the routes
// `/admin/settings/registration-fee*` and `/invoices/admin/families/:id/registration-credits/held`.
// Asserted, never validated: diff these against the backend when it changes.

import { apiClient } from '../services/api';

export interface RegistrationFeeSettings {
  creditOnFirstInvoice: boolean;
  /** A YYYY-MM-DD school day, or null = every fee paid. */
  creditFeesPaidFrom: string | null;
  scope: 'PER_FAMILY' | 'PER_STUDENT';
  waitlistLimitMonths: number;
  waitlistWarnDays: number;
}

export interface RegistrationFeePreview {
  /** Fees Held under today's settings (0 while the switch is off). */
  heldNow: number;
  /** Fees that would be Held if the credit were switched on for every fee already paid. */
  everyPaidFee: number;
}

export interface RegistrationFeeSettingsPatch {
  creditOnFirstInvoice?: boolean;
  /** Required when, and only when, the switch goes ON. */
  creditFrom?: 'ALL' | 'TODAY';
  scope?: RegistrationFeeSettings['scope'];
}

export interface HeldRegistrationCredit {
  studentId: string;
  studentName: string;
  registrationPaymentId: string;
  /** "50.00": what the credit would take off. */
  amount: string;
}

export interface HeldRegistrationCredits {
  creditOnFirstInvoice: boolean;
  children: HeldRegistrationCredit[];
}

export const registrationFeeSettingsApi = {
  get: (): Promise<RegistrationFeeSettings> =>
    apiClient.get<{ status: string; data: RegistrationFeeSettings }>('/admin/settings/registration-fee').then((r) => r.data),
  preview: (): Promise<RegistrationFeePreview> =>
    apiClient
      .get<{ status: string; data: RegistrationFeePreview }>('/admin/settings/registration-fee/preview')
      .then((r) => r.data),
  update: (patch: RegistrationFeeSettingsPatch): Promise<RegistrationFeeSettings & { heldCount: number }> =>
    apiClient
      .put<{ status: string; data: RegistrationFeeSettings & { heldCount: number } }>('/admin/settings/registration-fee', patch)
      .then((r) => r.data),
  held: (familyId: string, invoiceId: string): Promise<HeldRegistrationCredits> =>
    apiClient
      .get<{ status: string; data: HeldRegistrationCredits }>(
        `/invoices/admin/families/${familyId}/registration-credits/held`,
        { params: { invoiceId } }
      )
      .then((r) => r.data),
};
